const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  content: {
    gridArea: 'content',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: '"loginContent"',
  },
  form: {
    display: 'flex',
    maxWidth: '31rem',
    height: 'auto',
    flexDirection: 'column',
    background: theme.palette.common.white,
    borderRadius: props => (props.useCustomLogin ? '0.3rem' : 'unset'),
    color: theme.palette.common.black,
    gridArea: 'loginForm',
    padding: props => (props.useCustomLogin ? theme.spacing(2) : 'unset'),
  },
  login: {
    gridArea: 'loginContent',
    padding: '0 3rem',
    display: 'grid',
    gridTemplateColumns: '1fr 32rem 1fr',
    gridTemplateRows: '25% 1fr 20%',
    gridTemplateAreas: '". loginTitle ." ". loginForm ."',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: props =>
      props.useCustomLogin && props.useCustomColor ? props.customColor : theme.palette.primary.main,
    color: props =>
      props.useCustomLogin && props.useCustomTextColor && props.customTextColor
        ? props.customTextColor
        : '',
    '&:hover': {
      backgroundColor: props =>
        props.useCustomLogin && props.useCustomColor ? props.customColor : '',
    },
  },
  socialGoogleButton: {
    margin: theme.spacing(1, 0, 2),
    backgroundColor: '#dd4b39',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#dd4b39',
    },
  },
  microsoftContainer: {
    display: 'flex',
    '& > button:first-child': {
      'margin-right': props => (props.isAzureAuthEnabled && props.isAdfsAuthEnabled ? '1rem' : 0),
    },
  },
  socialMicrosoftButton: {
    margin: theme.spacing(1, 0, 2),
    backgroundColor: '#395d98',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#395d98',
    },
  },
  terms: {
    gridArea: 'loginForm',
  },
  title: {
    display: 'flex',
    alignItems: 'flex-end',
    gridArea: 'loginTitle',
    paddingBottom: theme.spacing(1 / 2),
    '& > h1': {
      fontFamily: '"Open Sans", open-sans, sans-serif',
      fontSize: '28px',
      fontWeight: '400',
      margin: 0,
      '& small': {
        display: 'block',
        marginTop: '10px',
        fontSize: '16px',
      },
    },
  },
  forgotContainer: {
    textAlign: 'left',
    marginTop: theme.spacing(2),
    fontSize: '0.75rem',
  },
  buttonProgress: {
    position: 'absolute',
  },
  activationEmailLink: {
    fontSize: '0.875rem',
    marginLeft: theme.spacing(1 / 4),
  },
  createAccount: {
    padding: theme.spacing(0, 0, 1, 0),
  },
  dialogRoot: {
    // borderRadius: '20px',
    // padding: '20px',
    maxWidth:'420px',
    margin:'7rem auto',

    background: 'white',
    borderRadius: '12px',
    border: '1px solid #e1e5e9',
    padding: '48px',
    width: '100%',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'

  },
  appbar: {
    color:theme.palette.secondary.white,
    backgroundColor:theme.palette.secondary.main,

  },
  dialogContainer: {
    display: 'flex',
  },
  logored:{
    width:'140px'
  },
  leftHalf: {
    flex: '1 1 0px',
    height: '35vh'
    // position: 'absolute',
    // left: '0px',
    // width: '50%',
  },

  rightHalf: {
    flex: '1 1 0px',
    // position: 'absolute',
    // right: '0px',
    // width: '50%',
  },

  textField: {
    '& .MuiOutlinedInput-input': {
      padding: '18.5px 14px',
    },
  },


})

export default styles